import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Pedido } from '../push-pedidos.component'

@Component({
    selector: 'push-pedidos-stepper',
    templateUrl: './push-pedidos-stepper.component.html',
    styleUrls: ['./push-pedidos-stepper.component.scss'],
    standalone: false
})
export class PushPedidosStepperComponent implements OnInit {

  constructor(public cd:ChangeDetectorRef) { }

  @Input() pedido:Pedido;

  step1Disabled = true;
  step2Disabled = true;
  step3Disabled = true;
  step4Disabled = true;
  finished = false;
  error = false;
  ngOnInit(): void {

      
  }

  ngAfterViewInit(){
    
    if ( this.pedido.status == '2'){
      this.step1Disabled = true;
      this.step2Disabled = true;
      this.step3Disabled = true;
      this.step4Disabled = true;
      this.error = true;
    }
    
    if ( this.pedido.status == '30' && this.pedido.erpOrder == 0 ){
      this.step1Disabled = false;
      this.step2Disabled = false;
      this.step3Disabled = false;
      this.step4Disabled = false;
    }

    if ( this.pedido.status == "19" && this.pedido.erpOrder == 0 ){
        this.step1Disabled = false;
    }

    if ( this.pedido.status == "21" && this.pedido.erpOrder == 0 ){
      this.step1Disabled = false;
      this.step2Disabled = false;
    }

    if ( this.pedido.status == "25" && this.pedido.erpOrder == 0 ){
      this.step1Disabled = false;
      this.step2Disabled = false;
    }

    if ( this.pedido.status == "27" && this.pedido.erpOrder == 0 ){
      this.step2Disabled = false;
      this.step3Disabled = false;
    }

    if ( this.pedido.status == '1' && this.pedido.erpOrder > 0  ){
      this.step1Disabled = false;
      this.step2Disabled = false;
      this.step3Disabled = false;
      this.step4Disabled = false;
      this.finished = true;
    }

    this.cd.detectChanges();
  }

}
